import Vue from 'vue'

//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {

  sites: {},
  siteTotal: 0,
  siteDetail: {
    data: {},
    messages: {
      extensions: [],
      backups: []
    },
    id: 0,
    details: false,
    dirty: false,
    inProgress: false
  },
  siteDetailId: 0,
  siteDetailsLoading: false,
  siteSelected: [],
  sitesFilter: {
    app_version: [],
    phpversion: [],
    database_version: []
  },
  allSelected: false,
  showDetailPage: false,
  showDetailPageConfiguration: false,
  showDetailPageExtensions: false,
  showDetailPageBackups: false,
  showDetailPageUpdatesites: false,
  allSitesList: {}
}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {
  sitesFilter: (state) => {
    return state.sitesFilter
  }
}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {

  /**
     * Add a site to the selected sites array
     *
     * @param state
     * @param payload
     */
  addSelectedSite (state, payload) {
    state.siteSelected.push(payload)
    if (state.siteSelected.length === state.sites.data.length) {
      state.allSelected = true
    }
  },

  /**
     * Closes all detail pages in whatever view we are at
     *
     * @param state
     */
  closeAllSiteDetailPages (state) {
    state.showDetailPage = false
    state.showDetailPageBackups = false
    state.showDetailPageConfiguration = false
    state.showDetailPageExtensions = false
    state.showDetailPageUpdatesites = false
  },

  /**
     * Close the detail page
     *
     * @param state
     */
  closeSiteDetailPage (state) {
    state.showDetailPage = false
  },

  /**
     * Close the backups detail page
     *
     * @param state
     */
  closeSiteDetailPageBackups (state) {
    state.showDetailPageBackups = false
  },

  /**
   * Close the updateistes detail page
   *
   * @param state
   */
  closeSiteDetailPageUpdatesites (state) {
    state.showDetailPageUpdatesites = false
  },

  /**
     * Close the configuration detail page
     *
     * @param state
     */
  closeSiteDetailPageConfiguration (state) {
    state.showDetailPageConfiguration = false
  },

  /**
     * Close the extension detail page
     *
     * @param state
     */
  closeSiteDetailPageExtensions (state) {
    state.showDetailPageExtensions = false
  },

  /**
     * Remove a site from the selected sites array
     *
     * @param state
     * @param payload
     */
  removeSelectedSite (state, payload) {
    state.siteSelected.splice(state.siteSelected.indexOf(payload), 1)
    state.allSelected = false
  },

  /**
     * Remove a site from the local store by id
     *
     * @param state
     * @param payload
     */
  removeSiteFromLocalStore (state, payload) {
    // Get the index where we have to save data within the sites array
    const idx = state.sites.data.findIndex((elm) => {
      return payload === elm.id
    })

    state.sites.data.splice(idx, 1)
  },

  /**
     * reset the selected sites array
     *
     * @param state
     */
  unsetSelectAll (state) {
    state.siteSelected = []
    state.allSelected = false
  },

  /**
     * Set sites detail property, get in out of the sites array
     *
     * @param state
     * @param payload
     */
  setSiteDetail (state, payload) {
    // Get the id
    const id = parseInt(payload.data.id)

    // Get the index where we have to save data within the sites array
    let idx = state.sites.data.findIndex((elm) => {
      return elm.id === id
    })

    // Site is not yet available in local sitelist storage, add empty row before assigning payload
    if (idx === -1) {
      state.sites.data.push(this.transformDataItem({ data: {}, process_state: 0, id: payload.data.id }))
      idx = state.sites.data.length - 1
    }

    state.sites.data[idx].data = payload.data
    state.sites.data[idx].details = true

    state.siteDetail = state.sites.data[idx]
  },

  setAllSites (state, payload) {
    state.allSitesList = payload
  },

  /**
     * Set a property of the site detail property
     *
     * @param state
     * @param payload
     */
  setSiteDetailProperty (state, payload) {
    let field = payload.field
    let value = payload.value

    state.siteDetail.data[field] = value
  },

  /**
     * Set the site id
     *
     * @param state
     * @param payload
     */
  setSiteDetailId (state, payload) {
    state.siteDetailId = payload
  },

  /**
     * Set the loading state of site details pages
     *
     * @param state
     * @param payload
     */
  setSiteDetailsLoading (state, payload) {
    state.siteDetailsLoading = payload
  },

  /**
     * Set the allSelected property (all sites in the sites view are selected)
     *
     * @param state
     * @param payload
     */
  setSelectAll (state, payload) {
    state.sites.data.forEach((item) => {
      state.siteSelected.push(item.id)
    })

    state.allSelected = true
  },

  /**
     * Set sites array, get data from the backend and convert it for better usage
     *
     * @param state
     * @param payload
     */
  setSites (state, payload) {
    // state.sites = payload;
    const data = payload.data
    const meta = payload.meta

    state.sites.meta = meta
    state.sites.data = []

    data.forEach((element) => {
      let site = this.transformDataItem(element)

      state.sites.data.push(site)
    })
  },

  /**
   * Set sites filter array, get data from the backend and convert it for better usage
   *
   * @param state
   * @param payload
   */
  setSitesFilter (state, payload) {
    state.sitesFilter = payload
  },

  /**
     * Show the detail page for the site with the id of siteDetailId
     *
     * @param state
     */
  showSiteDetailPage (state) {
    state.showDetailPage = true
  },

  /**
     * Show the backups detail page for the site with the id of siteDetailId
     *
     * @param state
     */
  showSiteDetailPageBackups (state) {
    state.showDetailPageBackups = true
  },

  /**
     * Show the configuration detail page for the site with the id of siteDetailId
     *
     * @param state
     */
  showSiteDetailPageConfiguration (state) {
    state.showDetailPageConfiguration = true
  },

  /**
     * Show the extension detail page for the site with the id of siteDetailId
     *
     * @param state
     */
  showSiteDetailPageExtensions (state) {
    state.showDetailPageExtensions = true
  },

  /**
   * Show the extension detail page for the site with the id of siteDetailId
   *
   * @param state
   */
  showSiteDetailPageUpdatesites (state) {
    state.showDetailPageUpdatesites = true
  },

  /**
     * Toggle the visibility of the detail page
     *
     * @param state
     */
  toggleSiteDetailPageVisibility (state) {
    state.showDetailPage = !state.showDetailPage
  },

  /**
     * Unselect all selected sites
     *
     * @param state
     * @param payload
     */
  unSelectAll (state, payload) {
    state.siteSelected = []
    state.allSelected = false
  },

  /**
     * Update the local store site information
     *
     * @param state
     * @param payload
     */
  updateLocalStoreSite (state, payload) {
    let fields = [
      'app_version',
      'core_need_update',
      'core_update_to',
      'extensions_installed',
      'extensions_need_update',
      'last_backup',
      'last_checked_backup',
      'last_checked_backup_state',
      'process_state',
      'state',
      'backups',
      'backup_tools',
      'backup_tools_installed',
      'extensions',
      'updates',
      'name',
      'remote_name',
      'phpversion',
      'plans',
      'audits',
      'updatesites',
      'file_ignorelist',
      'refresh_disabled',
      'description',
      'url_backend'
    ]

    // Check if siteDetailPage is the site with the id
    if (state.siteDetailId === payload.context.site_id) {
      fields.forEach((field) => {
        let value = payload.data[field]

        if (value === null) {
          value = []
        }

        Vue.set(state.siteDetail.data, field, value)
      })
    }

    state.sites.data.forEach((e) => {
      if (e.id === payload.context.site_id) {
        fields.forEach((field) => {
          Vue.set(e.data, field, payload.data[field])
        })
      }
    })

    if (state.allSitesList.data !== undefined) {
      state.allSitesList.data.forEach((e) => {
        if (e.id === payload.context.site_id) {
          fields.forEach((field) => {
            Vue.set(e, field, payload.data[field])
          })
        }
      })
    }
  },

  updateLocalStoreExtensionAutoUpdateState (state, payload) {
    let siteId = payload.data.id
    let euid = payload.context.euid
    let autoupdate = 0

    // Get extension ignore state
    payload.data.extensions.forEach((e) => {
      if (e.id === euid) {
        autoupdate = e.autoupdate_enabled
      }
    })

    // Check if siteDetailPage is the site with the id
    if (state.siteDetailId === siteId) {
      // Find updates
      state.siteDetail.data.updates.forEach((e) => {
        if (e.id === euid) {
          e.autoupdate_enabled = autoupdate
        }
      })

      // Find extensions
      state.siteDetail.data.extensions.forEach((e) => {
        if (e.id === euid) {
          e.autoupdate_enabled = autoupdate
        }
      })
    }
  },

  updateLocalStoreExtensionIgnoreUpdateState (state, payload) {
    let siteId = payload.data.id
    let euid = payload.context.euid
    let ignoreState = 0

    // Get extension ignore state
    payload.data.extensions.forEach((e) => {
      if (e.id === euid) {
        ignoreState = e.ignore_update
      }
    })

    // Check if siteDetailPage is the site with the id
    if (state.siteDetailId === siteId) {
      // Find updates
      state.siteDetail.data.updates.forEach((e) => {
        if (e.id === euid) {
          e.ignore_update = ignoreState
        }
      })

      // Find extensions
      state.siteDetail.data.extensions.forEach((e) => {
        if (e.id === euid) {
          e.ignore_update = ignoreState
        }
      })
    }
  },

  /**
     * Update the local store information for extensions
     *
     * @param state
     * @param payload
     */
  updateLocalStoreExtensionProcessState (state, payload) {
    let siteId = payload.data.id
    let euid = payload.context.euid
    let processState = 0

    // Get extension process state
    payload.data.updates.forEach((e) => {
      if (e.id === euid) {
        processState = e.process_state
      }
    })

    // Check if siteDetailPage is the site with the id
    if (state.siteDetailId === siteId) {
      // Find updates
      state.siteDetail.data.updates.forEach((e) => {
        if (e.id === euid) {
          if (e.process_state === 1 && processState === 0) {
            e.process_state = 2
          } else {
            e.process_state = processState
          }
        }
      })

      // Find extensions
      state.siteDetail.data.extensions.forEach((e) => {
        if (e.id === euid) {
          if (e.process_state === 1 && processState === 0) {
            e.process_state = 2
          } else {
            e.process_state = processState
          }
        }
      })
    }
  },

  /**
     * Update the local store process state for a site
     *
     * @param state
     * @param payload
     */
  updateLocalStoreSiteProcessState (state, payload) {
    // Check if siteDetailPage if the site with the id
    if (state.siteDetailId === payload.id) {
      state.siteDetail.process_state = payload.process_state
    }

    state.sites.data.forEach((e) => {
      if (e.id === payload.id) {
        e.process_state = payload.process_state
      }
    })
  },

  updateLocalStoreExtensionsAfterProcess (state, payload) {
    if (payload.id === state.siteDetailId) {
      let updates = state.siteDetail.data.updates

      updates.forEach((e) => {
        if (e.id === payload.extension_id) {
          e.process_state = payload.process_state_extension
          if (payload.process_state_extension === 0) {
            // Show success
            e.process_state = 2
          }
        }
      })

      let extensions = state.siteDetail.data.extensions

      extensions.forEach((e) => {
        if (e.id === payload.extension_id) {
          e.process_state = payload.process_state_extension
          if (payload.process_state_extension === 0) {
            // Show success
            e.process_state = 2
          }
        }
      })
    }
  }
}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  /**
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param payload
     */
  afterProcess ({ commit, dispatch, state }, payload) {
    /*
            id: payload.site_id,
            type: 'update',
            subtype: 'extension',
            extension_id: payload.id,
            site_id: payload.site_id,
            result: 'failed|success'
            process_state_extension: payload.process_state_extension,
            process_state_site: payload.process_state_site,
        */

    if (payload.type === 'update') {
      // We have updated an extension
      if (payload.subtype === 'extension') {
        commit('updateLocalStoreExtensionsAfterProcess', payload)
        dispatch('refreshSiteData', payload.id)
      }

      if (payload.subtype === 'core' || payload.subtype === 'site') {
        // We need to make a request to get the new site data
        dispatch('getSite', payload.id).then(
          response => {
            let result = {
              'data': response,
              'context': {
                'source': 'remote',
                'type': 'site',
                'site_id': payload.id
              }
            }

            commit('updateLocalStoreSite', result)
          }
        )
      }
    }
  },

  /**
     * Start a site remote information update
     *
     * @param commit
     * @param state
     * @param payload
     */
  enableRefreshSiteData ({ commit, state }, payload) {
    this._vm.axios.get('/api/site/' + payload + '/enablerefresh').then(
      response => {
        let result = {
          'data': response.data.data,
          'context': {
            'source': 'local',
            'type': 'site',
            'site_id': payload
          }
        }
        commit('updateLocalStoreSite', result)
      }
    )
  },

  /**
   * Get all site items for the view, as set internal state
   *
   * @param commit
   * @param state
   * @param payload
   *
   * @returns {Promise<any>}
   */
  getAllSites ({ commit, state }, payload) {
    let limit = 2000
    let sort = 'name'
    let dir = 'asc'
    let page = 1
    let search = ''

    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/accountsites?page=' + page + '&limit=' + limit + '&sort=' + sort + '&dir=' + dir + '&search=' + search)
        .then(response => {
          commit('setAllSites', response.data)
          resolve(response.data)
        })
    })
  },

  /**
     * Get site items for the view
     *
     * @param commit
     * @param state
     * @param payload
     *
     * @returns {Promise<any>}
     */
  getSites ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/accountsites', { params: payload })
        .then(response => {
          commit('setSites', response.data)
          resolve(response.data)
        }
        )
    })
  },

  /**
   * Get site filter for the view
   *
   * @param commit
   * @param state
   * @param payload
   *
   * @returns {Promise<any>}
   */
  getSitesFilter ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/accountsitesfilter', { params: payload })
        .then(response => {
          commit('setSitesFilter', response.data)
          resolve(response.data)
        }
        )
    })
  },

  /**
     * Get site items for the view
     *
     * @param state
     * @param payload
     *
     * @returns {Promise<any>}
     */
  getSite ({ state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/site/' + payload)
        .then(response => {
          resolve(response.data.data)
        }
        )
    })
  },

  /**
     * Start a site remote information update
     *
     * @param commit
     * @param state
     * @param payload
     */
  refreshSiteData ({ commit, state }, payload) {
    this._vm.axios.get('/api/site/' + payload + '/updateinfo').then(
      response => {
        let result = {
          'data': response.data.data,
          'context': {
            'source': 'local',
            'type': 'site',
            'site_id': payload
          }
        }
        commit('updateLocalStoreSite', result)
      }
    )
  },

  /**
     * Start refresh site information for all selected sites
     *
     * @param commit
     * @param dispatch
     * @param state
     */
  refreshDataForSelectedSites ({ commit, dispatch, state }) {
    state.siteSelected.forEach((e) => {
      dispatch('refreshSiteData', e)
    })

    commit('unsetSelectAll')
  },

  /**
     * Remove all selected sites
     *
     * @param commit
     * @param dispatch
     * @param state
     */
  removeAllSelectedSites ({ commit, dispatch, state }) {
    state.siteSelected.forEach((e) => {
      dispatch('removeSite', e)
    })
    commit('unsetSelectAll')
  },

  /**
     * Remove a site
     *
     * @param dispatch
     * @param state
     * @param payload
     */
  removeSite ({ dispatch, state }, payload) {
    this._vm.axios.delete('/api/site/' + payload).then(
      response => {
        let result = {
          'data': {},
          'context': {
            'source': 'local',
            'type': 'site',
            'subtype': 'remove',
            'site_id': payload
          }
        }
        dispatch('updateLocalStore', result)
      }
    )
  },

  /**
     * Save site configuration
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param payload
     */
  saveSiteConfiguration ({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/site/configuration', payload)
        .then(() => {
          payload = { id: payload.id, refresh: true }
          dispatch('setSiteDetailContentRefreshable', payload)
          this._vm.$snotify.success('Settings saved successfully')
        }
        ).catch(() => {
          this._vm.$snotify.error('Error while saving configuration, please try again')
        }
        )
    })
  },

  /**
     * Save site name
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param payload
     */
  saveSiteName ({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/site/name', payload)
        .then(response => {
          commit('updateLocalStoreSite', {
            'data': response.data.data,
            'context': {
              'site_id': payload.id
            }
          })
          resolve(response)
        }
        ).catch(error => {
          reject(error)
        }
        )
    })
  },

  /**
   * Save site description
   *
   * @param commit
   * @param dispatch
   * @param state
   * @param payload
   */
  saveSiteDescription ({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/site/description', payload)
        .then(response => {
          commit('updateLocalStoreSite', {
            'data': response.data.data,
            'context': {
              'site_id': payload.id
            }
          })
          resolve(response)
        }
        ).catch(error => {
          reject(error)
        }
        )
    })
  },

  /**
     * Save a plan for a site
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param payload
     */
  saveSitePlan ({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/site/plan', payload)
        .then(() => {
          this._vm.$snotify.success('Plan saved successfully')
        }
        ).catch(() => {
          this._vm.$snotify.error('Error while saving plan, please try again')
        }
        )
    })
  },

  /**
     * Set the content for the site detail page and show the page
     *
     * @param commit
     * @param state
     * @param payload
     */
  setSiteDetailContent ({ dispatch }, payload) {
    let siteDetailId = parseInt(payload)
    payload = { id: siteDetailId, refresh: false }
    dispatch('setSiteDetailContentRefreshable', payload)
  },

  /**
   * Set the content for the site detail page and show the page
   *
   * @param commit
   * @param state
   * @param payload
   */
  setSiteDetailContentRefreshable ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      let siteDetailId = parseInt(payload.id)
      let refresh = payload.refresh

      if (siteDetailId !== state.siteDetailId || refresh) {
        commit('setSiteDetailId', siteDetailId)
        commit('setSiteDetailsLoading', true)

        this._vm.axios.get('/api/site/' + state.siteDetailId)
          .then(
            response => {
              // Update the site detail information
              commit('setSiteDetail', response.data)
              commit('setSiteDetailsLoading', false)
              commit('audit/hideAuditDetail', 0, { root: true })
              commit('showSiteDetailPage')
              resolve(true)
            })
          .catch(
            () => {
              this._vm.$snotify.error('Error getting site data')
              resolve(false)
            })
      }
    })
  },

  /**
   * Update the autoupdate setting for an extension
   *
   * @param dispatch
   * @param payload   extension id
   */
  autoUpdateChangeById ({ dispatch }, payload) {
    dispatch('extensions/autoUpdateChangeById', payload, { root: true }).then(
      response => {
        dispatch('updateLocalStore', response)
      })
  },

  /**
     * Update an extension for a site
     *
     * @param dispatch
     * @param payload   extension id
     */
  toggleExtensionIgnoreState ({ dispatch }, payload) {
    dispatch('extensions/toggleExtensionIgnoreState', payload, { root: true }).then(
      response => {
        dispatch('updateLocalStore', response)
      })
  },

  /**
     * Update all extensions for a site, call from the detail view
     *
     * @param state
     * @param dispatch
     * @param payload
     */
  updateAllExtensionsForSite ({ state, dispatch }, payload) {
    let site = state.siteDetail

    if (site.id !== payload) {
      dispatch('getSite', payload).then(
        response => {
          response.updates.forEach((e) => {
            dispatch('updateExtension', e.id)
          })
        }
      )
    } else {
      site.data.updates.forEach((e) => {
        dispatch('updateExtension', e.id)
      })
    }
  },

  /**
     * Update all extensions for all selected sites, call from the site list
     *
     * @param state
     * @param dispatch
     * @param rootState
     */
  updateAllExtensionsForSelectedSites ({ state, dispatch }) {
    state.siteSelected.forEach((e) => {
      dispatch('updateAllExtensionsForSite', e)
    })
  },

  /**
     * Update an extension for a site
     *
     * @param dispatch
     * @param payload   extension id
     */
  updateExtension ({ dispatch }, payload) {
    dispatch('extensions/updateExtension', payload, { root: true }).then(
      response => {
        dispatch('updateLocalStore', response)
      })
  },

  /**
     * Update the local store based on action and source
     *
     * @param dispatch
     * @param state
     * @param payload
     */
  updateLocalStore ({ commit, state }, payload) {
    let context = payload.context

    if (context.source === 'local' && context.type === 'site') {
      commit('updateLocalStoreSiteProcessState', payload.data)
    }

    if (context.source === 'local' && context.type === 'extension') {
      commit('updateLocalStoreExtensionProcessState', payload)
    }

    if (
      context.source === 'local' &&
      context.type === 'extension' &&
      (context.subtype === 'ignore-update' || context.subtype === 'auto-update')
    ) {
      payload.context.site_id = payload.data.id
      commit('updateLocalStoreExtensionIgnoreUpdateState', payload)
      commit('updates/updateLocalStoreExtensionIgnoreUpdateState', payload, { root: true })
      commit('updateLocalStoreSite', payload)
    }

    if (context.source === 'local' && context.type === 'extension' && context.subtype === 'auto-update') {
      payload.context.site_id = payload.data.id
      commit('updateLocalStoreExtensionAutoUpdateState', payload)
      commit('updateLocalStoreSite', payload)
    }

    if (context.source === 'local' && context.type === 'site' && context.subtype === 'remove') {
      commit('removeSiteFromLocalStore', payload)
    }

    if (context.source === 'remote' && context.type === 'site') {
      commit('updateLocalStoreSite', payload)
    }

    if (context.source === 'remote' && context.type === 'extension') {
      commit('updateLocalStoreExtensionProcessState', payload)
    }
  },

  /**
   * Add a new site to the account
   *
   * @param commit
   * @param state
   * @param payload
   *
   * @returns {Promise<any>}
   */
  addNewSite ({ commit, state }, payload) {
    return this._vm.axios.post('/api/site', payload)
      .then(() => {}
      ).catch(() => {
        this._vm.$snotify.error('Could not add site')
      })
  },

  toggleFileIgnore ({ commit, state }, payload) {
    return this._vm.axios.post(`/api/site/togglefileignore`, payload)
      .then((response) => {
        let result = {
          'data': response.data.data,
          'context': {
            'source': 'local',
            'type': 'site',
            'site_id': payload.id
          }
        }

        commit('updateLocalStoreSite', result)
      }).catch(() => {
        this._vm.$snotify.error('Could not process file ignore')
      })
  }

}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
